import { render, staticRenderFns } from "./approvals_summary.vue.js?vue&type=template&id=b20b12ca!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approvals_summary.vue?vue&type=template&id=b20b12ca"
import script from "./approvals_summary.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approvals_summary.vue?vue&type=script&lang=js"
export * from "./approvals_summary.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approvals_summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports